import EventBase from "./EventBase";
import EventID from "./EventID";

class EventArray extends EventBase{
    /**
     * 223
     */
    public Code: EventID = EventID.Array
    constructor(){
        super()
        this.Parameter = [
            "0", "0", "0" , "0" , "2@1"
        ]
    }

    /**
     * 设置数组索引 (0)
     */
    set ArrayIndex(index:string){
        if (this.Parameter.length > 0){
            this.Parameter[0] = index
        }
    }

    /**
     * 获取数组索引 (0)
     */
    get ArrayIndex(){
        if (this.Parameter.length > 0){
            return this.Parameter[0]
        } else {
            return ""
        }
    }

    /**
     * 获取操作符 (1)
     */
    get Operation(){
        if (this.Parameter.length > 1){
            return this.Parameter[1]
        } else {
            return ""
        }
    }

    /**
     * 设置操作符 (1)
     */
    set Operation(opreate:string){
        if (this.Parameter.length > 1){
            this.Parameter[1] = opreate
        }
    }

    /**
     * 获取操作符2 (2)
     */
    get Operation2(){
        if (this.Parameter.length > 2){
            return this.Parameter[2]
        } else {
            return ""
        }
    }

    /**
     *  设置操作符2 (2)
     */
    set Operation2(opreate:string){
        if (this.Parameter.length > 2){
            this.Parameter[2] = opreate
        }
    }

    /**
     * 设置操作数值 (类型0时，为索引值；类型为1时，为取值数量)   ---  (3)
     */
    set Value(val:string){
        if (this.Parameter.length > 3){
            this.Parameter[3] = val
        }
    }

    /**
     * 获取操作数值 (类型0时，为索引值；类型为1时，为取值数量) ---  (3)
     */
    get Value(){
        if (this.Parameter.length > 3){
            return this.Parameter[3]
        } else {
            return ""
        }
    }

    /**
     * 取值参数 ( 例子: 0@1|2@1 参考 Scene 传入和传出参数)) ---  (4)
     */
    get Operand():{type:string, value: string}[]{
        if (this.Parameter.length > 4){
            const outputParams = this.Parameter[1].split('|')
            return outputParams.map(val => ({ type: val.split('@')[0],  value: val.split('@')[1] }))
        } else {
            return []
        }
    }

    /**
     * 取值参数 ( 例子: 0@1|2@1 参考 Scene 传入和传出参数)) ---  (4)
     */
     set Operand(val: {type:string, value: string}[]){
        if (this.Parameter.length > 4){
            const str = val.reduce((acc, cur, index, array) => {
                var ex = index < array.length - 1 ? `${cur.type}@${cur.value}|` : `${cur.type}@${cur.value}`
                return acc + ex
            },"") 
            this.Parameter[4] = str
        }
    }

    get Description() {
        return `数组操作 [${this.Parameter[0]}] `
    }

}
export default EventArray